var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'electron-layout': _vm.isElectron
  },attrs:{"id":"app"}},[(_vm.isElectron)?_c('ElectronCommon'):_vm._e(),_c('div',{staticClass:"h-100 w-100 main-app"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }